<template>
    <div class="row justify-content-center animated fadeInRight">
        <loading v-if="loading" message="Сбрасываем пароль..."></loading>
        <div v-else-if="error" class="col-lg-6 col-md-8 col-sm-12">
            <div class="card p-4">
                <div class="card-block">
                    <h1>Ошибка сброса пароля</h1>
                    <div class="alert alert-danger">
                        {{error}}
                    </div>
                    <router-link class="btn btn-primary" :to="{ name: 'RemindPassword' }">Вернуться к странице сброса пароля</router-link>
                </div>
            </div>
        </div>
        <form v-else class="col-lg-6 col-md-8 col-sm-12" v-on:submit.prevent="resetPassword()">
            <div class="card-group mb-0">
                <div class="card p-4">
                    <div class="card-block">
                        <h1>Задать новый пароль</h1>
                        <p class="text-muted mt-2 mb-2">
                            Укажите уникальный новый пароль
                        </p>
                        <div class="form-group row" :class="{ 'has-danger': $v.newPassword.$error }">
                            <label for="new-password" class="col-12 col-md-6 col-form-label">Новый пароль</label>
                            <div class="col-12 col-md-6 ">
                                <input class="form-control" name="firstname" type="password" id="new-password" v-model="newPassword" @input="$v.newPassword.$touch()">
                                <span class="small help-block text-danger" v-if="$v.newPassword.$error">Новый пароль должен быть не менее 6 символов</span>
                            </div>
                        </div>
                        <div class="form-group row" :class="{ 'has-danger': $v.remindNewPassword.$error }">
                            <label for="remind-new-password" class="col-12 col-md-6  col-form-label">Повторите новый пароль</label>
                            <div class="col-12 col-md-6 ">
                                <input class="form-control" name="firstname" type="password" id="remind-new-password" v-model="remindNewPassword" @input="$v.remindNewPassword.$touch()">
                                <span class="small help-block text-danger" v-if="$v.remindNewPassword.$error">Пароли должны совпадать</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-12 offset-md-6 col-md-6">
                                <button type="submit" :class="{ 'disabled': $v.remindNewPassword.$invalid }" :disabled="$v.remindNewPassword.$invalid" class="btn btn-primary">Сменить пароль</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
  import { resetPasswordUrl } from './../../config'
  import { required, minLength, sameAs } from 'vuelidate/lib/validators'

  export default {
    name: 'ResetPasswordEmail',
    data () {
      return {
        loading: false,
        error: false,
        newPassword: null,
        remindNewPassword: null
      }
    },
    methods: {
      resetPassword () {
        this.error = false
        this.loading = true
        const postData = {
          token: this.$route.query.token,
          email: this.$route.query.email,
          password: this.newPassword,
          password_confirmation: this.remindNewPassword
        }
        this.$http.post(resetPasswordUrl, postData).then((response) => {
          this.loading = false
          if (response.status === 200) {
            const authUser = {}
            authUser.access_token = response.data.meta.token
            window.sessionStorage.setItem('authUser', JSON.stringify(authUser))
            this.loading = false
            this.$router.push({name: 'Dashboard'})
          }
        }, (response) => {
          this.error = response.response.data.message
          this.loading = false
          console.log(response.response.data)
        })
      }
    },
    validations: {
      newPassword: {
        required,
        minLength: minLength(6)
      },
      remindNewPassword: {
        sameAsPassword: sameAs('newPassword')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ResetPasswordEmail.vue?064ecc57